import {
    ActionService,
    collection,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {inject, Injectable} from "@angular/core";
import {OrderItemData, UnavailabilityReason} from "./order-initiation.service";
import {OrderType} from './order';

export class AvailableOrderTimesRequestData extends EntityData<AvailableOrderTimesRequestData> {
    @field expectedCompletion: string;
    @field orderType: string;
    @field allowCarryOverTimes: boolean;
    @collection(OrderItemData) items: OrderItemData[];

    public set orderTypeEnum(orderType: OrderType) {
        this.orderType = OrderType.toString(orderType);
    }
}

export class AvailableOrderTimeData extends EntityData<AvailableOrderTimeData> {
    @field time: string;
    @field carryOver: boolean;
    @field available: boolean;
    @field unavailabilityReason: UnavailabilityReason;
}

export class AvailableOrderTimesGroupData extends EntityData<AvailableOrderTimesGroupData> {
    @collection(AvailableOrderTimeData) specificTimes: AvailableOrderTimeData[];
}

export class AvailableOrderTimesResponseData extends EntityData<AvailableOrderTimesResponseData> {

    /**
     * The earliest date and time that the order can be fulfilled in the formats of yyyy-MM-dd and h:mma
     */
    @field earliestLocalDate: string;
    @field earliestLocalTime: string;

    @collection(AvailableOrderTimesGroupData) specificTimeGroups: AvailableOrderTimesGroupData[];
}

@Injectable({providedIn: "root"})
export class AvailableOrderTimesService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        super(http, nameSpace, "available-order-times", configService, useAsync, actionNames);
    }
}
